import { ContentSection } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { LogoutSuccess } from '../../components/auto-logout-success';

export const LogoutSuccessPage: React.FC = () => (
    <ContentSection pageWrap pageWrapSize="medium">
        <LogoutSuccess />
    </ContentSection>
);
